import { useForm } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function BankStatementForm() {
  const { setData, post, processing, errors, transform } = useForm<{
    csv_document: File | null;
  }>({
    csv_document: null,
  });

  transform((data) => {
    return { bank_statement: data };
  });

  function handleSubmit(e: React.SyntheticEvent<HTMLFormElement>) {
    e.preventDefault();

    post(`/bank_statements`, {
      preserveScroll: "errors",
    });
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="bank_statement_csv_document">CSV document</Label>
        <Input
          id="bank_statement_csv_document"
          type="file"
          onChange={(e) => setData("csv_document", e.target.files?.[0] ?? null)}
          aria-invalid={!!errors.csv_document}
          accept=".csv,text/csv"
        />
        {errors.csv_document && (
          <p className="text-destructive text-sm">{errors.csv_document}</p>
        )}
      </div>
      <div className="flex justify-end">
        <Button type="submit" disabled={processing}>
          Create bank statement
        </Button>
      </div>
    </form>
  );
}
